import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Button, Close } from "../UI";
import { WalletContext } from "../context/WalletContext";

const ModalOverlay = styled.div`
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  overflow: none;
  background: rgba(0, 0, 0, 0.25);
  z-index: 999;
  position: absolute;
  top: 0;
  display: none;
  &.visible {
    display: flex;
    justify-content: center ;
    align-items: center ;
  }
`;

const ModalCard = styled.div`
  border: 1px solid #fff;
  background-color: #fff;
  color: #000;
  border-radius: 22px;
  padding: 25px 50px;
  width: 460px;
  height: 460px;
  line-height: 25px;
  font-size: 16px;
  font-weight: 100;
  z-index: 1000;

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .before {
      width: 20%;
    }
    .heading {
      width: 60%;
      text-align: center;
    }
    .close {
      width: 20%;
      display: flex;
      justify-content: end;
      position: relative;
      right: -40px;
      top: -20px;
    }
  }

  .header i {
    position: absolute;
    right: 0;
    border: 1px solid #000;
    border-radius: 100%;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #000;
    cursor: pointer;
  }

  hr {
    margin-top: 20px;
    border: 1px solid #000;
  }

  .body {
    text-align: center;
    margin-top: 50px;
    min-height: 100px;
  }

  .footer {
    text-align: center;
    margin-top: 20px;
  }
`;

export default function Modal({ ...props }) {
  const { connect } = useContext(WalletContext);
  const [isOpen, setIsOpen] = useState(props.modalVisible);
  const [active, setActive] = useState(false);

  const style ={
    width: props.width,
    height: props.height,
    padding: props.padding,
  }

  const handleClose = (e, parent=false) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if(parent && props.closable) {
      setIsOpen(false);
      setIsOpen(false);
      props.closable();
    }
  }

  useEffect(() => {
    setIsOpen(props.modalVisible);
  }, [props.modalVisible])

  useEffect(() => {
    document.body.classList.add("App-noscroll");
    return () => {
      document.body.classList.remove("App-noscroll");
    };
  });

  return (
    <>
    <div className="overlay"></div>
      <ModalOverlay onClick={(e) => handleClose(e, true)} className={isOpen ? "visible" : ""}>
        <ModalCard  style={style}>
       {  props.modalHeading && <div className="header">
            <div className="before"></div>
            <h3 className="heading">{props.modalHeading}</h3>
            <div className="close">
              <Close onClick={props.modalTrigger}>&#10005;</Close>
            </div>
          </div>}
          <div>{props.htmlBody()}</div>
          <div className="footer"></div>
        </ModalCard>
      </ModalOverlay>
    </>
  );
}
